import { html } from "htm/preact";
import { ctx, translate, Quote, punchout } from "..";
import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";

const Button = ({
    clickHandler
}) => {
    return html`
    <button onclick=${clickHandler} type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light">
        <span>${translate('Delete')}</span>
    </button>
    `
}

function QuoteItem(quote: Quote) {
    const { state, dispatch } = ctx();

    console.log(state.role, 'current role')

    const onApproveClick = (quote: Quote) => {

        fetch('https://punchout.cloud/api/v1/quotes/' + quote.id + '/approve?role=approver', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('punchout_id') || '',
            },
        })
            .then(res => res.json())
            .then(() => {
                punchout.submitCart({
                    items: quote.items.map(it => ({ ...it, product: { ...it.data, price: Math.round(it.price * 0.1) } })) as any,
                    currency: translate('USD'),
                })
                    .then(() => { });
            })
            .catch(err => console.error(err));
    };

    const onRejectClick = (quote: Quote) => {
        fetch('https://punchout.cloud/api/v1/quotes/' + quote.id + '/reject?role=approver', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('punchout_id') || '',
            },
        })
            .then(res => res.json())
            .then(() => {
                dispatch({ type: 'quote.reject', quote });

            });
    };

    const onAddToCartClick = (quote: Quote) => {

        quote.items.forEach(it => {
            dispatch({ type: 'add', product: { ...it.data, price: it.price * 0.001 }, quantity: it.quantity, options: {} });
        });
    };

    const onDeleteQuoteClick = (targetQuote: Quote) => {
        fetch('https://punchout.cloud/api/v1/quotes/' + targetQuote.id, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('punchout_id') || '',
            }
        })
        .then(() => window.location.reload())
        .catch(console.error);

        console.log(state.quotes, 'list of quotes')

        dispatch({
            type: 'quotes',
            quotes: state.quotes.filter(quote => quote != targetQuote)
        })
        
    }

    return html`<div class="card ecommerce-card" style="width:100%">
    <div class="card-body">
        <div class="item-wrapper">
            <div>
                <h6 class="item-name">${translate('Requester')}: ${quote.contact_name} - ${quote.email} - ${quote.data.department || ''}</h6>
                <h6 class="item-price">${translate('Total')}: ${(quote.items.reduce((p, n) => p + n.price * n.quantity, 0) * 0.001).toFixed(2).replace(".", ",")} ${translate('USD')}</h6>
                <h6 class="item-name">${translate('Created At')}: ${quote.created_at.split('.')[0].replace('T', ' ')}</h6>
                <h6 class="item-name">${translate('Status')}: ${quote.status}</h6>
            </div>
        </div>
    </div>
    <table class="table table-borderless">
    <thead>
        <tr>
            <th class="text-start">
                <h6 class="item-name">${translate('Item')}</h6>
            </th>
            <th class="text-end">
                <h6 class="item-price">${translate('Quantity')}</h6>
            </th>
            <th class="text-end">
                <h6 class="item-price">${translate('Price')}</h6>
            </th>
        </tr>
    </thead>
        <tbody>
        ${quote.items.map(it => html`<tr>
                <td class="text-start">
                    <h6 class="item-name">${it.name}</h6>
                </td>
                <td class="text-end">
                    <h6 class="item-price">${it.quantity}</h6>
                </td>
                <td class="text-end">
                    <h6 class="item-price">${(it.price * 0.001 || 0).toFixed(2)} ${translate('USD')}</h6>
                </td>
            </tr>`)}

        </tbody>
    </table>
    ${state.role == 'approver' ? html`
    <div class="item-options" style="margin:10px;text-align:right">

    <button style="margin-right:10px" onclick=${() => onAddToCartClick(quote)} type="button" class="btn btn-primary mt-1 remove-wishlist waves-effect waves-float waves-light">
        <span>${translate('Add to cart')}</span>
    </button>

        ${/* quote.status == 'pending' ? html`<button style="margin-right:10px" onclick=${() => onApproveClick(quote)} type="button" class="btn btn-primary mt-1 remove-wishlist waves-effect waves-float waves-light">
            <span>${translate('Approve and Punchout')}</span>
</button>`: '' */ ''}
        
        ${ /* quote.status == 'pending' ? html`<button onclick=${() => onRejectClick(quote)} type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light" style="margin-right: 10px;">
            <span>${translate('Reject')}</span>
        </button>`: */ ''}

        <button onclick=${() => onDeleteQuoteClick(quote)} type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light">
            <span>${translate('Delete')}</span>
        </button>
        </div>`: html`<div class="item-options" style="margin:10px;text-align:right"><${Button} clickHandler=${() => onDeleteQuoteClick(quote)} /></div>`}
</div>`;
}

export default function QuotesView() {
    const { state, dispatch } = ctx();

    const [localLoading, setLocalLoading] = useState(true);

    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (!localStorage.getItem('punchout_id')) {
            route('/');
            return;
        }
        fetch('https://punchout.cloud/api/v1/quotes', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('punchout_id') || '',
            },
        })
            .then(res => res.json())
            .then((quotes: Quote[]) => {
                dispatch({ type: 'quotes', quotes });
                setLocalLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLocalLoading(false);
            });
    }, []);

    if (localLoading) {
        return html`<div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
            <div class="text-center d-flex flex-column align-items-center justify-content-center gap-1">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <span class="fw-bold">${translate('Loading Quotes...')}</span>
            </div>
        </div>`;
    }



    function search(quotes: Quote[]) {
        if (!searchText) return quotes;
        const searchTextLowercase = searchText.toLowerCase();
        return quotes.filter(quote => {
            return JSON.stringify(quote).toLowerCase().includes(searchTextLowercase);
        });
    }

    return html`<div class="app-content content ecommerce-application">
    <h2 style="margin:10px;text-align:center">${translate('Quotes')}</h2>                
    <div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="bs-stepper checkout-tab-steps">
            <input type="text" id="search" class="form-control" placeholder="Search" style="margin:10px" value=${searchText} onkeyup=${ev => setSearchText(ev.target.value)} />


            <div class="bs-stepper-content">
                <!-- Checkout Place order starts -->
                <div id="step-cart" class="content active dstepper-block" role="tabpanel" aria-labelledby="step-cart-trigger">
                            ${search(state.quotes).map(QuoteItem)}
                </div>

            </div>

        </div>
    </div>
</div>
</div>`;


}